import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-logo-xxl',
  templateUrl: './logo-xxl.component.html',
  styleUrls: ['./logo-xxl.component.scss']
})
export class LogoXxlComponent {
  @Input() isLanding: boolean = false;
  @Output() logoClick = new EventEmitter<void>();

  onClick() {
    this.logoClick.emit();
  }
}
